<template>
  <DashboardTrendStack class="listing-trends" title="Listing trends" :snapshot="snapshot" :rows="rows" :metrics="metrics" :loading="loading" :error="error"
    :period="period" definition="Active listings include deferred listings; verification rate and unverified counts exclude them."
    @update:period="$emit('update:period', $event)" @retry="$emit('retry')" />
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed } from 'vue';
import { dashboardListingPopulation } from '@strenforcement/domain/dashboardListings';
import DashboardTrendStack from './DashboardTrendStack.vue';
const props = defineProps({ snapshot: { type: Object, required: true }, rows: { type: Array, default: () => [] }, loading: Boolean, error: String, period: Number });
defineEmits(['retry', 'update:period']);
const population = computed(() => dashboardListingPopulation(props.snapshot));
const metrics = computed(() => [
  { metric: 'activeListings', label: 'Active listings', value: props.snapshot.inventory?.activeListings ?? null, color: '#3f4247', definition: 'Includes deferred listings.' },
  { metric: 'verificationRate', label: 'Verification rate', value: population.value?.rate ?? null, color: '#3b7dd8', definition: 'Verified property / address among non-deferred active listings.' },
  { metric: 'unverifiedListings', label: 'Unverified listings', value: population.value?.unverified ?? null, color: '#b8860b', definition: 'Excludes deferred listings.' }
]);
</script>
